import React, { useContext } from 'react'
// import { useLocation } from '@reach/router'
import { gsap } from 'helpers/gsap'

import { ThemeContext } from '../../helpers/ThemeProvider'

import { Wrap, Logo } from './index.styled'

const Header = ({ className, isHomePage, ...props }) => {
  const { siteTheme } = useContext(ThemeContext)

  React.useEffect(() => {
    gsap.to('#logo', {
      y: '-200%',
      // duration: 3,
      scrollTrigger: {
        trigger: '#startPoint',
        start: 'top top',
        end: '+=150px',
        scrub: true
        //  markers: true,
      }
    })
  }, [])

  return (
    <Wrap className={[className, siteTheme].join(' ')} {...props}>
      <Logo id='logo' to='/' />
    </Wrap>
  )
}
export default Header
